import { css } from '@emotion/core';


export const LTR_SHADOW = css`
  box-shadow: rgba(0,0,0,0.15) 10px 4px 8px 2px
`;

export const RTL_SHADOW = css`
  box-shadow: rgba(0, 0, 0, 0.15) -10px 4px 8px 2px;
`;
